import styled from "styled-components";
import { colors } from "@aifi-ml/design-system-variables";
import { font } from "src/styles/themes";

export const GoBackButton = styled.button`
  background: none;
  border: none;
  color: ${() => colors.light['color/text/general/active']};
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.4px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-family: ${font.family.fromVariable};
  position: relative;
  z-index: 1;
  padding: 0;
  margin-top: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    text-decoration: underline;
  }
`;
